var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"superadmin":""}},[_c('template',{slot:"main"},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }